import _Model from "./_Model";

export default class DeviceAccessory extends _Model {
  constructor(json) {
    super(json);
    this.accessory = DeviceAccessory.getOrDefault(json, 'accessory', '');
    this.type = DeviceAccessory.getOrDefault(json, 'type', null);
    this.quantity = DeviceAccessory.getMappedOrDefault(json, 'quantity', 0, v => parseInt(v));
    this.minQty = DeviceAccessory.getMappedOrDefault(json, 'minQty', 0, v => parseInt(v));
    this.maxQty = DeviceAccessory.getMappedOrDefault(json, 'maxQty', 0, v => parseInt(v));
    this.subAccessories = DeviceAccessory.getOrDefault(json, 'subAccessories', []);
  }

  extractSelectedSubAccessories() {
    return this.subAccessories.map(subAcc => {
      return {
        id: subAcc.accessory,
        quantity: subAcc.quantity,
        minQty: subAcc.minQty,
        maxQty: subAcc.maxQty
      }
    });

  }
}
